'use client'

import type { Data } from '@repo/strapi'
import { useTranslations } from 'next-intl'
import { FeatureComparisonTable } from '@/components/page-builder/global/pricingV1/featureComparison/FeatureComparisonTable'
import { PlanTabs } from '@/components/page-builder/global/pricingV1/shared/PlanTabs'
import Heading from '@/components/typography/Heading'
import { cn } from '@/lib/styles'
import { PRICING_TEST_IDS } from '@/lib/test-ids'

export function FeatureComparison({
	data,
	yearly,
	currentTab,
	setCurrentTab,
}: {
	data?: Data.Component<'shared.pricing-plan-detail'>[] | null
	yearly?: boolean
	currentTab: string
	setCurrentTab: (value: string) => void
}) {
	const t = useTranslations('pricing')
	return (
		<div className="mt-0 lg:mt-10 relative bg-brand-black" data-test-id={PRICING_TEST_IDS.COMPARE}>
			<Heading
				tag="h2"
				fontSize="displayMedium"
				className="text-center w-full text-neutral-light-100"
			>
				{t('compareFeatures')}
			</Heading>

			{/* Mobile */}
			<PlanTabs
				currentTab={currentTab}
				setCurrentTab={setCurrentTab}
				data={data}
				renderContent={(item) => (
					<FeatureComparisonTable data={data} currentTab={item?.title} yearly={yearly} />
				)}
				className="w-full py-5.5 lg:hidden"
			/>

			{/* Desktop */}
			<FeatureComparisonTable
				data={data}
				yearly={yearly}
				className={cn('hidden lg:block lg:pt-7.25', !yearly && 'max-w-200 mx-auto')}
			/>
		</div>
	)
}
